// extracted by mini-css-extract-plugin
export default {"close":"Feedback_close__4+dZY"};